import { data } from "./data"
import { TypedAccessor } from "./types"
import { ActiveChip } from "../ActiveChip"
import { TableCellWidth } from "../TableCell"
import { DataColumn } from "../useTable/types"

type ActiveAccessorFn<T> = TypedAccessor<T, boolean | undefined>
type ActiveColumn<T> = Omit<DataColumn<T>, "type" | "renderCell" | "width">
export type ActiveColumnHelper<T> = (
  accessorFn: ActiveAccessorFn<T>,
  col: ActiveColumn<T>
) => DataColumn<T>

export function active<T>(
  accessorFn: ActiveAccessorFn<T>,
  col: ActiveColumn<T>
): DataColumn<T> {
  return data({
    renderCell: (rowData) => {
      const isActive = accessorFn(rowData)
      if (isActive === undefined) return null
      return <ActiveChip isActive={isActive} />
    },
    width: TableCellWidth.Small,
    ...col,
  })
}
